import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { UserType } from 'types/user.types';

import { AppReminder } from './AppReminder';

const mapStateToProps = ({ userData }) => ({
  user: userData?.user,
  contact: userData?.contact,
});

type Props = {
  user: UserType;
};

const AppReminderContainer = (props: Props) => {
  const { user } = props;
  const [isOpen, setOpen] = useState(false);

  const showAppPromotionModal = async () => {
    // If disabled in localStorage, return immediately (no useless requests)
    const disabledInLocalStorage = localStorage.getItem('doNotShowAppPromotion') === 'true';

    if (disabledInLocalStorage) {
      return;
    }

    // If enabled, do the dice rolling and show app promotion
    if (!isOpen) {
      const showProbabilityPercentage = Math.floor(Math.random() * 100) + 1;

      setOpen(showProbabilityPercentage <= 5);
    }
  };

  // Show modal mount
  useEffect(() => {
    showAppPromotionModal();
  }, [user?.isLoggedIn]);

  return <AppReminder closeModal={() => setOpen(false)} isOpen={isOpen} />;
};

export default connect(mapStateToProps)(AppReminderContainer);
